import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../../../hooks/useGraphQLMutation.hook';

export const UserCmp_Settings_AuthenticatedUser_UiSettings_Save_Mutation =
  graphql(`
    mutation UserCmp_Settings_AuthenticatedUser_UiSettings_Save(
      $paletteModeId: Id!
      $themeMainColor: SocnaColorEnum
      $isContextualColorEnabled: Boolean!
    ) {
      saveAuthenticatedUserUiSettings(
        paletteModeId: $paletteModeId
        themeMainColor: $themeMainColor
        isContextualColorEnabled: $isContextualColorEnabled
      ) {
        paletteModeId
        themeMainColor
        isContextualColorEnabled
      }
    }
  `);

export const useSaveAuthenticatedUserUiSettingsMutation = () =>
  useGraphQLMutation(
    UserCmp_Settings_AuthenticatedUser_UiSettings_Save_Mutation,
  );
